import { Grid, TextField } from '@mui/material';
import styled from 'styled-components';

import { InboundTaskItemStatusEnum } from 'commons/enums';
import CommonComponentStyle from 'commons/styles/basic-components.styles';

class InboundItemAssignStyles extends CommonComponentStyle {
  GridWrapper = styled(Grid)`
    padding: 8px 0;
  `;

  TaskDocumentMainInfoWrapper = styled(Grid)`
    margin: 16px 0;
  `;

  DocumentNumberText = styled(Grid)`
    font-size: 16px;
    font-weight: 700;
  `;

  VendorText = styled(Grid)`
    font-size: 14px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  ContentWrapper = styled.div`
    padding: 16px 0;
    padding-bottom: 80px;
  `;

  StickyFooterWrapper = styled(this.FooterWrapper)`
    position: sticky;
    align-items: center;
    justify-content: center;
  `;

  SearchBar = styled(TextField)`
    width: 100%;
    margin-bottom: 8px !important;
  `;

  TaskItemWrapper = styled(Grid)`
    background-color: ${this.colors.LIGHTER_GRAY};
    padding: 8px 0;
    margin-top: 8px;
  `;

  TaskItemSkuCode = styled(Grid)`
    font-size: 14px;
    font-weight: 700;
  `;

  TaskItemDescription = styled(Grid)`
    font-size: 12px;
    font-weight: 700;
  `;

  TaskItemQTY = styled(Grid)`
    font-size: 12px;
    font-weight: 700;
    float: right;
  `;

  TaskItemStatus = styled.div<{
    status: InboundTaskItemStatusEnum;
    isSameUser?: boolean;
  }>`
    font-size: 12px;
    display: inline-block;
    padding: 2px 4px;
    color: ${({ status, isSameUser }) =>
      status === InboundTaskItemStatusEnum.QUEUE
        ? this.colors.PRIMARY_GRAY
        : isSameUser
        ? this.colors.PRIMARY_BLUE
        : this.colors.PRIMARY_RED};
    border: 1px solid
      ${({ status, isSameUser }) =>
        status === InboundTaskItemStatusEnum.QUEUE
          ? this.colors.PRIMARY_GRAY
          : isSameUser
          ? this.colors.PRIMARY_BLUE
          : this.colors.PRIMARY_RED};
    border-radius: 8px;
    &::before {
      content: '${({ status, isSameUser }) =>
        status === InboundTaskItemStatusEnum.QUEUE
          ? 'Available'
          : isSameUser
          ? 'Assigned to you'
          : 'Assigned to other'}';
    }
  `;

  TaskItemAssignButton = styled(this.SecondaryButton)<{
    status: InboundTaskItemStatusEnum;
    isSameUser?: boolean;
  }>`
    display: ${({ status, isSameUser }) =>
      isSameUser || status === InboundTaskItemStatusEnum.QUEUE
        ? 'block'
        : 'none'} !important;
    &::after {
      content: '${({ status }) =>
        status === InboundTaskItemStatusEnum.QUEUE
          ? 'Assign'
          : 'Unassign'}' !important;
    }
  `;

  FOCText = styled.span`
    border-radius: 8px;
    font-size: 10px;
    background: ${this.colors.LIGHTER_ORANGE};
    color: ${this.colors.PRIMARY_ORANGE};
    padding: 6px;
  `;
}

export const InboundItemAssignStyle = new InboundItemAssignStyles();
